import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import Tooltip from "@mui/material/Tooltip";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import FileBase64 from "../../components/Upload/UploadFile";
import { dealerWithdrawEMoneyList } from "../../redux/actions/dealerGetWithdrawEMoneyListAction";
import { dealerReqWithdrawEMoney } from "../../redux/actions/dealerReqWithdrawEMoneyAction";
import { dealerCashLiftingList } from "../../redux/actions/dealerCashLiftingListAction";
import { dealerReqCashLifting } from "../../redux/actions/dealerReqCashLiftingAction";
import { dealerBankName } from "../../redux/actions/dealerBankNameAction";
import { dealerBranchName } from "../../redux/actions/dealerBranchNameAction";
import { dealerAccountNumber } from "../../redux/actions/dealerAccountNumberAction";
import SOLogout from "../../components/Logout/SOLogout";
import Util from "../../validation/index";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function WithdrawEMoney() {
	const navigate = useHistory();
	const [addNotification, setAddNotification] = useState(false);
	const [editNotification, setEditNotification] = useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(true);
	const [addOpen, setAddOpen] = useState(false);

	const [withdrawEMoneyListStatus, setWithdrawEMoneyListStatus] =
		useState(false);
	const [withdrawEMoneyListArray, setWithdrawEMoneyListArray] = useState("");

	const [cashLiftingListStatus, setCashLiftingListStatus] = useState(false);
	const [cashLiftingListArray, setCashLiftingListArray] = useState("");

	const [reqWithdrawEMoneyStatus, setReqWithdrawEMoneyStatus] = useState(false);
	const [reqWithdrawEMoneyArray, setReqWithdrawEMoneyArray] = useState("");

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [UploadFileName, setUploadFileName] = useState("");
	const [uploadFile, setUploadFile] = useState("");

	const [requestInput, setRequestInput] = useState({
		bankName: "",
		branchName: "",
		accountNum: "",
		amount: "",
		accountType: ""
	});

	const { bankName, branchName, accountNum, amount, accountType } =
		requestInput;

	const onInputChangeMod = ({ target: { name, value } }, type) => {
		const obj = {
			...requestInput
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			obj[name] = value
		}
		setRequestInput(obj);
	};

	const [user, setUser] = useState({
		bankNameSearch: "",
		branchNameSearch: ""
	});

	const { bankNameSearch, branchNameSearch } = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			obj[name] = value
		}
		setUser(obj);
	};

	const cashLiftingListRes = useSelector(
		({ dealerCashLiftingList }) => dealerCashLiftingList
	);

	const withdrawEMoneyListRes = useSelector(
		({ dealerGetWithdrawEMoneyList }) => dealerGetWithdrawEMoneyList
	);

	const reqWithdrawEMoneyRes = useSelector(
		({ dealerReqWithdrawEMoney }) => dealerReqWithdrawEMoney
	);

	const bankNameRes = useSelector(({ dealerBankName }) => dealerBankName);

	const branchNameRes = useSelector(({ dealerBranchName }) => dealerBranchName);

	const accountNumberRes = useSelector(({ dealerAccountNumber }) => dealerAccountNumber);

	const handleAttachmentsDoc = (e, uploadFile) => {
		if (uploadFile == "uploadFile") {
			setUploadFile(e.base64);
			setUploadFileName(e.name);
		}
	};

	const withdrawEMoneyListReq = () => {
		setWithdrawEMoneyListStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId,
				bankName: bankNameSearch.split(",")[1],
				branchName: branchNameSearch.split(",")[1]
			}
		};
		dispatch(dealerWithdrawEMoneyList(req, authToken));
	};

	const withdrawEMoneyListFunc = () => {
		if (withdrawEMoneyListStatus) {
			if (withdrawEMoneyListRes.data.status == "success") {
				setWithdrawEMoneyListArray(
					[].concat(withdrawEMoneyListRes.data.errorList)
				);
				setIsLoading(false);
			}
			if (withdrawEMoneyListRes.data.status == "failed") {
				setWithdrawEMoneyListArray(withdrawEMoneyListRes.data);
				setIsLoading(false);
				if (
					withdrawEMoneyListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					withdrawEMoneyListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		withdrawEMoneyListFunc();
	}, [withdrawEMoneyListRes.data.status]);

	const reqWithdrawEMoneyReq = () => {
		setReqWithdrawEMoneyStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId,
				bankName: bankName.split(",")[1],
				branchName: branchName.split(",")[1],
				accountNumber: accountNum,
				amount: amount,
				accountType: accountType
			}
		};
		dispatch(dealerReqWithdrawEMoney(req, authToken));
		setAddOpen(false);
	};

	const reqWithdrawEMoneyFunc = () => {
		if (reqWithdrawEMoneyStatus) {
			if (reqWithdrawEMoneyRes.data.status == "success") {
				setReqWithdrawEMoneyArray(reqWithdrawEMoneyRes.data);
				withdrawEMoneyListReq();
				setEditNotification(true);
			}
			if (reqWithdrawEMoneyRes.data.status == "failed") {
				setReqWithdrawEMoneyArray(reqWithdrawEMoneyRes.data);
				setEditNotification(true);
				if (
					reqWithdrawEMoneyRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					reqWithdrawEMoneyRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		reqWithdrawEMoneyFunc();
	}, [reqWithdrawEMoneyRes.data.status]);

	const bankNameReq = () => {
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId
			}
		};

		dispatch(dealerBankName(req, authToken));
	};

	const branchNameReq = () => {
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId,
				bankCode: bankName.split(",")[0] || bankNameSearch.split(",")[0]
			}
		};

		dispatch(dealerBranchName(req, authToken));
	};

	useEffect(() => {
		setUser({
			bankNameSearch: bankNameSearch,
			branchNameSearch: ""
		})
		setRequestInput({
			bankName: bankName,
			branchName: "",
			accountNum: "",
			amount: amount,
			accountType: ""
		})
		if (bankName || bankNameSearch) {
			branchNameReq();
		}
	}, [bankName, bankNameSearch]);

	const accountNumberReq = () => {
		let req = {
			actionCustomerMasterRequestVO: {

				dealerId: regenerateTokenRes.data.partnerId,
				branchCode: branchName.split(",")[0],
				bankCode: bankName.split(",")[0]
			}
		}
		dispatch(dealerAccountNumber(req, authToken))
	}

	useEffect(() => {
		if (branchName && bankName) {
			accountNumberReq()
		}
	}, [branchName, bankName])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			withdrawEMoneyListReq();
			bankNameReq();
		}
	}, [regenerateTokenRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setAddOpen(false);
		setRequestInput({
			accountId: "",
			chargeValue: "",
			DynamicInput: "",
			sequenceNum: ""
		});
	};

	const openAdd = () => {
		setAddOpen(true);
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setAddNotification(false);
		setEditNotification(false);
		setRequestInput({
			bankName: "",
			branchName: "",
			accountNum: "",
			amount: "",
			accountType: ""
		})
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px",
							textAlign: "center"
						}}
					>
						<Grid item xs={12} md={8} sm={3} lg={8}></Grid>
						<Grid item xs={12} md={4} sm={3} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => openAdd()}
							>
								Request Withdraw E-Money
							</CustomButton>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Bank Name"
								fullWidth={true}
								name="bankNameSearch"
								defaultValue={bankNameSearch || ""}
								onChange={(e) => onInputChange(e, "")}
							>
								<MenuItem value="" selected="">
									Select Bank Name
								</MenuItem>
								{bankNameRes.success &&
									[]
										.concat(bankNameRes.data.list)
										.map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Branch Name"
								fullWidth={true}
								name="branchNameSearch"
								defaultValue={branchNameSearch || ""}
								onChange={(e) => onInputChange(e, "")}
							>
								<MenuItem
									value=""
									selected=""
								>
									Select Branch Name
								</MenuItem>
								{branchNameRes.success &&
									[]
										.concat(branchNameRes.data.list)
										.map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={withdrawEMoneyListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : withdrawEMoneyListArray.length == undefined ||
					!withdrawEMoneyListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Summary Data
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 themeBackground"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow className="themeBackground">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Request ID{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Bank Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Branch Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Account Type
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Account Number
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Amount
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Remark
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{withdrawEMoneyListArray &&
												[]
													.concat(withdrawEMoneyListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.requestId}
															</TableCell>
															<TableCell align="center">
																{row.bankName}
															</TableCell>
															<TableCell align="center">{row.branchName}</TableCell>
															<TableCell align="center">
																{row.transactionType}
															</TableCell>
															<TableCell align="center">
																{row.payMode}
															</TableCell>
															<TableCell align="center">{row.amount}</TableCell>
															<TableCell align="center">{row.status}</TableCell>
															<TableCell align="center">
																{row.statusDescription}
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(withdrawEMoneyListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
			</Layout>

			<div>
				<Dialog open={addOpen} onClose={handleClose}>
					<DialogTitle>Request Withdraw E-Money</DialogTitle>
					<DialogContent>
						<TextField
							select
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Bank Name"
							fullWidth={true}
							name="bankName"
							defaultValue={bankName || ""}
							onChange={(e) => onInputChangeMod(e, "")}
						>
							<MenuItem value="" selected="">
								Select Bank Name
							</MenuItem>
							{bankNameRes.success &&
								[]
									.concat(bankNameRes.data.list)
									.map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
						</TextField>
						<TextField
							select
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Branch Name"
							fullWidth={true}
							name="branchName"
							defaultValue={branchName || ""}
							onChange={(e) => onInputChangeMod(e, "")}
						>
							<MenuItem
								value=""
								selected=""
							>
								Select Branch Name
							</MenuItem>
							{branchNameRes.success &&
								[]
									.concat(branchNameRes.data.list)
									.map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
						</TextField>
						<TextField
							select
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Account Number"
							fullWidth={true}
							name="accountNum"
							defaultValue={accountNum || ""}
							onChange={(e) => onInputChangeMod(e)}
						>
							<MenuItem
								value=""
								selected=""
							>
								Select Account Number
							</MenuItem>
							{accountNumberRes.success &&
								[]
									.concat(accountNumberRes.data.list)
									.map((x) => <MenuItem value={x.code}>{x.code}</MenuItem>)}
						</TextField>
						<TextField
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="number"
							label="Amount"
							fullWidth={true}
							name="amount"
							value={amount || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
						<TextField
							select
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="number"
							label="Account Type"
							fullWidth={true}
							name="accountType"
							value={accountType || ""}
							onChange={(e) => onInputChangeMod(e)}
						>
							<MenuItem
								value=""
								selected=""
							>
								Select Account Type
							</MenuItem>
							<MenuItem value="Savings">Savings</MenuItem>
							<MenuItem value="Current">Current</MenuItem>
							<MenuItem value="Business Account">Business Account</MenuItem>
						</TextField>
					</DialogContent>
					<DialogActions style={{ padding: "14px" }}>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={handleClose}
						>
							Cancel
						</CustomButton>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={reqWithdrawEMoneyReq}
						>
							Add
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>

			{reqWithdrawEMoneyRes.success && (
				<div>
					<Dialog open={editNotification} onClose={handleNoticationClose}>
						<DialogContent className="text-center lightThemeBackground">
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{reqWithdrawEMoneyRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{reqWithdrawEMoneyRes.failed && (
				<div>
					<Dialog open={editNotification} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{reqWithdrawEMoneyRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default WithdrawEMoney;
